document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

(function () {
  const forms = document.querySelectorAll('.nd-product-form');
  forms.forEach((form) => {
    const select = form.querySelector('[name="id"]');
    if (!select) return;
    const submit = form.querySelector('[type="submit"]');
    const updateButton = () => {
      const selected = select.options[select.selectedIndex];
      if (!submit || !selected) return;
      submit.disabled = selected.disabled;
      submit.textContent = selected.disabled ? 'Uitverkocht' : 'Toevoegen aan winkelwagen';
    };
    select.addEventListener('change', updateButton);
    updateButton();
  });
})();

(function () {
  const homeHeader = document.querySelector('.template-index .section-header');
  if (!homeHeader) return;
  const updateHeader = () => homeHeader.classList.toggle('nd-is-scrolled', window.scrollY > 26);
  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();
})();
